"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalytics = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _react = require("react");
var _context = require("../../../context");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const MAP_PAGE_TYPE_TO_CATEGORY = {
  project: 'CSP',
  card: 'Card'
};
const useAnalytics = _ref => {
  let {
    showEscrow
  } = _ref;
  const {
    pageType,
    objectId
  } = (0, _context.useAppContext)();
  const trackMortgageAnalytics = (0, _react.useCallback)(data => {
    (0, _analytics.ca)('eventSite', _objectSpread({
      ea: 'Click',
      ec: MAP_PAGE_TYPE_TO_CATEGORY[pageType]
    }, data));
  }, [pageType]);
  const trackMortgageButtonClick = (0, _react.useCallback)(() => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_banner',
      products: [{
        id: objectId,
        extra: {
          escrow: showEscrow
        }
      }]
    });
  }, [objectId, showEscrow, trackMortgageAnalytics]);
  const trackMortgageProgramClick = (0, _react.useCallback)(programId => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_program',
      products: [{
        id: objectId,
        extra: {
          type: programId,
          escrow: showEscrow
        }
      }]
    });
  }, [objectId, showEscrow, trackMortgageAnalytics]);
  const trackNoOfferClick = (0, _react.useCallback)(() => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_no_offer',
      products: [{
        id: objectId,
        extra: {
          escrow: showEscrow
        }
      }]
    });
  }, [objectId, showEscrow, trackMortgageAnalytics]);
  const trackMortgageModalButtonClick = (0, _react.useCallback)(programId => {
    trackMortgageAnalytics({
      el: 'Mortgage_modal',
      products: [{
        id: objectId,
        extra: {
          type: programId,
          escrow: showEscrow
        }
      }]
    });
  }, [objectId, showEscrow, trackMortgageAnalytics]);
  const trackMortgageOnlineLabelClick = (0, _react.useCallback)(programId => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_program_label',
      products: [{
        id: objectId,
        extra: {
          type: programId,
          escrow: showEscrow
        }
      }]
    });
  }, [objectId, showEscrow, trackMortgageAnalytics]);
  return (0, _react.useMemo)(() => ({
    trackMortgageButtonClick,
    trackMortgageProgramClick,
    trackNoOfferClick,
    trackMortgageModalButtonClick,
    trackMortgageOnlineLabelClick
  }), [trackMortgageButtonClick, trackMortgageModalButtonClick, trackMortgageProgramClick, trackNoOfferClick, trackMortgageOnlineLabelClick]);
};
exports.useAnalytics = useAnalytics;